var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home mt-5 mx-3 h-full"},[_c('logbook-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }